import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/frontend-plugin-api';
import { spikeOAuthRequestDialogTranslationRef } from '../translation';

export const spikeOAuthRequestDialogTranslations = createTranslationResource({
  ref: spikeOAuthRequestDialogTranslationRef,
  translations: {
    'pt-BR': async () => {
      const m = await import('./pt-BR.json');
      return {
        default: createTranslationMessages({
          ref: spikeOAuthRequestDialogTranslationRef,
          full: false,
          messages: m.default,
        }),
      };
    },
  },
});
